// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__ZXJgO","title":"ClientInsurance_title__22L08","itemText":"ClientInsurance_itemText__2Ha61"};